// extracted by mini-css-extract-plugin
export var button = "contact-form-module--button--DId5F";
export var container = "contact-form-module--container--XpATq";
export var errorText = "contact-form-module--error-text--TPGnH";
export var form = "contact-form-module--form--CoO8-";
export var inputs = "contact-form-module--inputs--S3m+K";
export var successMessage = "contact-form-module--successMessage--g3SP1";
export var title = "contact-form-module--title--8kGC+";